module.exports = __webpack_public_path__ + "static/media/BIMpic8.08b42905.png";